const IrisStickyTimerUrl = '/content-aggregator/shared-components/zones/SiteWideTimer';

export default {
    IrisStickyTimerUrl,
};
